import { render, staticRenderFns } from "./SwitchesArray.vue?vue&type=template&id=48d19c72&"
import script from "./SwitchesArray.vue?vue&type=script&lang=js&"
export * from "./SwitchesArray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports